import React from 'react'

export const Label = ({children}: {children: React.ReactNode}) => {
    return (
        <label className='text-base font-bold text-large_oak'>{children}</label>
    )
}